<script>
import FormHeader from '@/components/FormHeader'
import { Card, Pagination, Icon, Popover } from 'ant-design-vue'
import moment from 'moment'
import { getAction } from '@/command/netTool'
export default {
  data() {
    return {
      current: 1,
      size: 7,
      searchData: {},
      loading: false,
      records: [],
      total: 0,
    }
  },
  mixins: [],
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      const params = {
        current: this.current,
        size: this.size,
        ...this.searchData,
      }
      if (this.searchData.beginDate && this.searchData.endDate) {
        params.beginDate = moment(this.searchData.beginDate).format('YYYY-MM-DD')
        params.endDate = moment(this.searchData.endDate).format('YYYY-MM-DD')
      } else {
        delete params.beginDate
        delete params.endDate
      }
      this.loading = true
      getAction('/file/exportHis/page', params)
        .then((e) => {
          this.loading = false
          this.records = e.data['records']
          this.size = e.data['size']
          this.current = e.data['current']
          this.total = e.data['total']
        })
        .catch(() => {
          this.loading = false
        })
    },
    getHeader() {
      return [
        {
          name: '搜索下载记录',
          key: 'fileName',
          type: 'input',
        },
        {
          name: '日期范围',
          type: 'rangePicker',
          keys: ['beginDate', 'endDate'],
          showTimeNo: true,
        },
      ]
    },
    renderHeader() {
      return (
        <FormHeader
          style={{ paddingLeft: '26px' }}
          data={this.getHeader()}
          onSuccess={(data) => {
            this.searchData = { ...this.searchData, ...data }
            this.current = 1
            this.getList()
          }}
          onReset={() => {
            this.searchData = {}
            this.size = 7
            this.getList()
          }}
        />
      )
    },
    renderPagination() {
      const scopedSlots = {
        buildOptionText: (props) => {
          return <div>{props.value !== '999999' ? <span>{props.value}条/页</span> : <span>全部</span>}</div>
        },
      }

      return (
        <div class="template-pagination">
          <Pagination
            total={this.total}
            current={this.current}
            showSizeChanger={true}
            pageSize={this.size || 10}
            pageSizeOptions={['7', '20', '30', '40', '999999']}
            onShowSizeChange={(data, pageSize) => {
              this.size = pageSize
              this.current = 1
              this.getList()
            }}
            onChange={(data, pageSize) => {
              this.size = pageSize
              this.current = data
              this.getList()
            }}
            {...{ scopedSlots }}
          />
        </div>
      )
    },
    renderBody() {
      return (
        <div class="template-body">
          <div class="template-body-list">
            {this.records.map((item) => {
              return (
                <div class="template-body-item">
                  <div class="template-body-item-content">
                    <div class="template-body-item-icon">
                      <Icon type="file-text" theme="filled" style={{ color: '#1890ff', fontSize: '32px' }} />
                    </div>
                    <div class="template-body-item-info">
                      <div class="template-body-item-title">{item.fileName}</div>
                      <div class="template-body-item-time">
                        下载时间: {moment(item.createTime).format('YYYY-MM-DD')}
                      </div>
                    </div>
                  </div>
                  <div class="template-body-item-actions">
                    {item.exportState == '2' && (
                      <div class="template-body-item-actions-msg">
                        <Icon type="check-circle" style={{ color: '#00FF00', fontSize: '18px', marginRight: '5px' }} />
                        导出成功
                      </div>
                    )}
                    {item.exportState == '1' && (
                      <div class="template-body-item-actions-msg">
                        <Icon type="close-circle" style={{ color: '#FF0000', fontSize: '18px', marginRight: '5px' }} />
                        导出失败
                      </div>
                    )}
                    <div class="template-body-item-actions-block">
                      {item.exportState == '1' && (
                        <Popover
                          placement="topLeft"
                          scopedSlots={{
                            content: () => (
                              <div class="template-body-item-actions-msg">
                                <Icon type="bell" style={{ color: 'orange', fontSize: '18px', marginRight: '5px' }} />
                                失败原因：
                                {item.exportResult || '导出超时...'}
                              </div>
                            ),
                          }}
                        >
                          <Icon type="info-circle" style={{ color: '#FF0000', fontSize: '18px' }} />
                        </Popover>
                      )}

                      {item.exportState == '0' && <span>正在导出中，请耐心等待</span>}
                      {item.exportState == '2' && <a href={item.fileUrl}>下载</a>}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          {this.records.length <= 0 && <div class="template-body-empty">暂无数据</div>}
        </div>
      )
    },
  },
  render() {
    return (
      <Card>
        {this.renderHeader()}
        {this.renderBody()}
        {this.renderPagination()}
      </Card>
    )
  },
}
</script>

<style lang="less" scoped>
.template-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.template-body-empty {
  text-align: center;
  margin: 50px auto 50px;
}

.template-body-item {
  border: 1px solid #e8e8e8;
  padding: 15px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.template-body-item-content {
  display: flex;
  align-items: center;
}
.template-body-item-info {
  margin-left: 15px;
}

.template-body-item-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.template-body-item-time {
  font-size: 12px;
  color: #999;
}
.template-body-item-actions {
  display: flex;
  align-items: center;
  font-size: 16px;
}
.template-body-item-actions-msg {
  display: flex;
  align-items: center;
}
.template-body-item-actions-block {
  display: flex;
  align-items: center;
  width: 200px;
  justify-content: flex-end;
}

.template-pagination {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
